var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrEth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 28,
    viewBox: "0 0 17 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63887 0.791016L8.45996 1.39872V19.0313L8.63887 19.2098L16.8235 14.3717L8.63887 0.791016Z",
    fill: "#BCC9F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63898 0.791016L0.454102 14.3717L8.63898 19.2098V10.6514V0.791016Z",
    fill: "#F8F8F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63892 20.7594L8.53809 20.8823V27.1633L8.63892 27.4576L16.8286 15.9238L8.63892 20.7594Z",
    fill: "#BCC9F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63898 27.4576V20.7594L0.454102 15.9238L8.63898 27.4576Z",
    fill: "#F6F7F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63965 19.2097L16.8243 14.3717L8.63965 10.6514V19.2097Z",
    fill: "#7894EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.454102 14.3717L8.63898 19.2097V10.6514L0.454102 14.3717Z",
    fill: "#BCC9F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrEth);
export default __webpack_public_path__ + "static/media/pr-eth.3021cb482f467d38f5419772f0071be7.svg";
export { ForwardRef as ReactComponent };